import type {
  TourTypeControllerCreateData,
  TourTypeControllerCreateResponse,
  TourTypeControllerFindAllData,
  TourTypeControllerFindAllResponse,
  TourTypeControllerRemoveData,
  TourTypeControllerRemoveResponse,
  TourTypeControllerUpdateData,
  TourTypeControllerUpdateResponse,
} from '~/api';
import {
  tourTypeControllerCreate,
  tourTypeControllerFindAll,
  tourTypeControllerRemove,
  tourTypeControllerUpdate,
} from '~/api';
import { heyApiQuery } from '~/utils/api';

import api from '..';

export const tourTypes = api.injectEndpoints({
  endpoints: builder => ({
    paginateTourTypes: builder.query<TourTypeControllerFindAllResponse, TourTypeControllerFindAllData['query']>({
      queryFn: query => heyApiQuery(() => tourTypeControllerFindAll({ query })),
      providesTags: result =>
        result?.success
          ? [
              ...result.data.items.map(({ id }: { id: number }) => ({ type: 'TOUR_TYPE', id }) as const),
              { type: 'TOUR_TYPE', id: 'ALL' },
            ]
          : [{ type: 'TOUR_TYPE', id: 'ALL' }],
    }),
    createTourType: builder.mutation<
      TourTypeControllerCreateResponse,
      { params: TourTypeControllerCreateData['body'] }
    >({
      queryFn: ({ params }) => heyApiQuery(() => tourTypeControllerCreate({ body: params })),
      invalidatesTags: () => [{ type: 'TOUR_TYPE', id: 'ALL' }],
    }),
    updateTourType: builder.mutation<
      TourTypeControllerUpdateResponse,
      { id: TourTypeControllerUpdateData['path']['id']; params: TourTypeControllerUpdateData['body'] }
    >({
      queryFn: ({ id, params }) => heyApiQuery(() => tourTypeControllerUpdate({ path: { id }, body: params })),
      invalidatesTags: () => [{ type: 'TOUR_TYPE', id: 'ALL' }],
    }),
    deleteTourType: builder.mutation<TourTypeControllerRemoveResponse, TourTypeControllerRemoveData['path']['id']>({
      queryFn: id => heyApiQuery(() => tourTypeControllerRemove({ path: { id } })),
      invalidatesTags: () => [{ type: 'TOUR_TYPE', id: 'ALL' }],
    }),
  }),
  overrideExisting: false,
});
